module.exports = __webpack_public_path__ + "static/media/Outfit_800ExtraBold.1249dc19.ttf";